export default __webpack_public_path__ + "static/media/reports-2.81b21670.png";